import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovRedistributionStateProps,
    LoadMarkovRedistributionStateFromById,
    setMarkovRedistributionStateFromEdit,
    setMarkovRedistributionStateFromReloadEdit,
    initMarkovRedistributionStateFrom,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    stateId = null,
}: MarkovRedistributionStateProps) => {
    const redistributionSelected = useSelector((state: StoreType) => state.markovRedistribution.redistributionSelected)

    const redistributionState = useSelector((state: StoreType) => state.markovRedistributionState.from.stateEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovRedistributionState.from.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovRedistributionStateFromReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovRedistributionStateFromReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (stateId === 0) {
            dispatch(setMarkovRedistributionStateFromEdit(initMarkovRedistributionStateFrom))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovRedistributionStateFromById(stateId, redistributionSelected.id).then((res) => {
                dispatch(setMarkovRedistributionStateFromEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!redistributionState) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editRedistributionState}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form redistributionState={redistributionState} />
                }
                {
                    reloadEdit
                    && <Form redistributionState={redistributionState} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
